import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { Flex } from '~shared/ui/atoms/Flex';

export const StyledUserAvatar = styled(Flex)`
	overflow: hidden;

	width: 7.2rem;
	height: 7.2rem;
	border-radius: 50%;
	font-size: var(--font-size-4xl);
	line-height: 100%;
`;

export const avatarImage = css`
	object-fit: cover;
`;
